import type React from 'react';

import type { Themes } from '@this/constants/themes';
import type { AITTheme } from '@this/shared/ui/theme';

export function getBaseReceiptFormStyles(isLoading: boolean, theme: Themes & AITTheme) {
  const isMobile = window.innerWidth <= 768;

  return {
    container: {
      minHeight: '85vh',
      maxWidth: '1150px',
      width: '90%',
      margin: '20px auto',
      padding: '20px',
      background: theme.fieldBgColor,
      position: 'relative' as const,
      ...(isLoading && {
        opacity: 0.5,
        pointerEvents: 'none' as const
      })
    } as React.CSSProperties,

    loadingOverlay: {
      position: 'fixed' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      zIndex: 10
    } as React.CSSProperties,

    title: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: isMobile ? '20px' : '30px'
    } as React.CSSProperties,

    section: {
      marginBottom: isMobile ? '20px' : '30px'
    } as React.CSSProperties,

    subTitle: {
      fontSize: '15px',
      fontWeight: 'bold',
      wordWrap: 'break-word'
    } as React.CSSProperties,

    label: {
      fontSize: '13px',
      wordWrap: 'break-word',
      width: isMobile ? '100%' : '200px',
      alignItems: 'center',
      display: 'flex'
    } as React.CSSProperties,

    required: {
      paddingLeft: '4px',
      fontSize: '15px',
      fontWeight: 'bold',
      color: theme.redColor
    } as React.CSSProperties,

    childContent: {
      display: 'flex',
      flexDirection: isMobile ? ('column' as const) : ('row' as const),
      gap: isMobile ? '4px' : '20px',
      padding: isMobile ? '8px 0 0 10px' : '10px 20px'
    } as React.CSSProperties,

    errorText: {
      color: theme.redColor,
      fontSize: '13px',
      marginTop: '5px',
      wordWrap: 'break-word'
    } as React.CSSProperties,

    noticeText: {
      margin: 0,
      fontSize: '14px',
      lineHeight: 1.6
    } as React.CSSProperties,

    checkText: {
      marginLeft: '8px',
      fontSize: '14px',
      lineHeight: 1.6
    } as React.CSSProperties,

    checkboxContainer: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px'
    } as React.CSSProperties,

    buttonContainer: {
      position: 'absolute' as const,
      bottom: isMobile ? '10px' : '20px',
      left: '0',
      display: 'flex',
      gap: '20px',
      justifyContent: isMobile ? 'center' : 'flex-start',
      paddingLeft: isMobile ? '0' : '20px'
    } as React.CSSProperties,

    confirmBack: {
      cursor: 'pointer',
      margin: 'auto 0',
      fontSize: '12px',
      fontWeight: 'bold',
      color: theme.linkColor
    } as React.CSSProperties,

    isMobile
  };
}
